import axios from 'axios';

export const TOKEN_PREFIX = 'QSTN_JOIN_';
export const ERROR_LOGINFAIL = 400017;

export const SERVER_ENV_PROD = 'PROD';
export const REQ_URL_CN_PROD = 'https://poster-api.xd.cn/api/v1.0/questionnaire';
export const REQ_URL_CN_TEST = 'https://poster-api.xd.cn/api/v1.0/activity-dev/questionnaire';
export const REQ_URL_GLOBAL_PROD = 'https://poster-api.xd.com/api/v1.0/questionnaire';

axios.defaults.withCredentials = false;

export function getTokenKey(code) {
  return `${TOKEN_PREFIX}${code}`;
}

const request = axios.create({
  timeout: 86400000,
});

const uploadRequest = axios.create({
  timeout: 86400000,
});

request.interceptors.request.use(function(config) {
  const tokenKey = getTokenKey(config.formCode);
  config.headers.Authorization = localStorage.getItem(tokenKey) || '';
  return config;
});

request.interceptors.response.use(function(response) {
  const data = response.data;
  if (data && data.error === 0) return data.data || {};
  return data;
}, function (error) {
  const { response = {}, config = {} } = error;
  const data = response.data || {};

  if (!config.withoutToast) {
    let message;

    switch (data.error) {
      case ERROR_LOGINFAIL:
        message = '验证码错误';
        break;

      default:
        message = data.message || '请求失败，请重试';
    }
  }
  return Promise.reject(data);
});

export const get = function(url, params, formCode, config = {}) {
  const mergedConfig = Object.assign({
    params,
    formCode,
  }, config || {});
  return request.get(url, mergedConfig);
};

export const post = function(url, data, formCode, config = {}) {
  const mergedConfig = Object.assign({
    formCode,
  }, config || {});
  return request.post(url, data, mergedConfig);
};

export const ossUpload = function(url, data, config = {}) {
  return uploadRequest.post(url, data, config);
}

export default request;